var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button is-info is-small",class:{ 'is-loading': _vm.loading },on:{"click":_vm.downloadPdf}},[_c('b-icon',{attrs:{"icon":"file-pdf","size":"is-small"}}),_c('span',[_vm._v("Download PDF")])],1),(_vm.errorMessage)?_c('b-message',{attrs:{"type":"is-danger"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }